import styled from 'styled-components';

import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { colors, fontFamilySize, px } from '../../../../../../contrib/ui';

export const StyledContestSelectorItem = styled.div`
  .paper {
    padding: ${px(10)} !important;
    margin-bottom: ${px(15)};

    &.selected-contest {
      background-color: ${colors.greydd};
    }

    .grid-container {
      .grid-item {
        .contestName,
        .contestType,
        .formatType {
          line-height: 1.3;
          margin: 0;
        }
        .contestName {
          ${fontFamilySize('Bold', 16)}
        }
        .contestType {
          ${fontFamilySize('Medium', 14)}
        }
        .formatType {
          ${fontFamilySize('Medium', 14)}
          text-transform: uppercase
        }
      }
    }
  }
`;

export const CheckCircleRoundedIconStyled = styled(CheckCircleRoundedIcon)`
  color: #6ce1c1;
`;

export const RadioButtonUncheckedRoundedIconStyled = styled(RadioButtonUncheckedRoundedIcon)`
  color: #ababab;
`;
